import React from 'react';
const scrollToPricing = () => {
  document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth'
  });
};
export function BonusSection() {
  return <section className="w-full bg-gray-50 py-12 md:py-16 px-4" data-id="element-13">
      <div className="max-w-3xl mx-auto" data-id="element-14">
        <div className="text-center mb-10" data-id="element-15">
          <h2 className="text-3xl md:text-4xl font-black font-heading text-gray-900 mb-2" data-id="element-16">
            🎁 MAS LOS 3 BONOS ESTRATÉGICOS
          </h2>
          <p className="text-lg text-gray-600 font-body" data-id="element-17">
            Gratis solo por HOY, luego cambiará de precio y no vuelve a estar
            gratis
          </p>
        </div>

        {/* Bonus 1 */}
        <div className="bg-white rounded-2xl p-6 mb-6 border-2 border-yellow-300 shadow-md relative overflow-hidden" data-id="element-18">
          <div className="absolute top-0 right-0 bg-red-600 text-white text-xs font-bold px-4 py-1 rounded-bl-xl" data-id="element-19">
            🎁 GRATIS HOY
          </div>
          <div className="flex flex-col md:flex-row items-start gap-4" data-id="element-20">
            <div className="bg-yellow-100 rounded-xl p-4 flex-shrink-0" data-id="element-21">
              <span className="text-4xl" data-id="element-22">🎁</span>
            </div>
            <div className="flex-1" data-id="element-23">
              <p className="text-sm font-bold text-yellow-600 mb-1 font-heading" data-id="element-24">
                BONO 1
              </p>
              <h3 className="text-xl font-black font-heading text-gray-900 mb-2" data-id="element-25">
                Kit Visual de Rutinas
              </h3>
              <p className="text-gray-600 font-body mb-3" data-id="element-26">
                Rutinas listas, tarjetas visuales y tableros para organizar el
                día sin gritos
              </p>
              <div className="flex items-center gap-3" data-id="element-27">
                <span className="text-gray-400 line-through text-sm" data-id="element-28">
                  💰 Valor: USD 9
                </span>
                <span className="bg-green-100 text-green-700 font-bold text-sm px-3 py-1 rounded-full" data-id="element-29">
                  🎁 GRATIS
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Bonus 2 */}
        <div className="bg-white rounded-2xl p-6 mb-6 border-2 border-yellow-300 shadow-md relative overflow-hidden" data-id="element-30">
          <div className="absolute top-0 right-0 bg-red-600 text-white text-xs font-bold px-4 py-1 rounded-bl-xl" data-id="element-31">
            🎁 GRATIS HOY
          </div>
          <div className="flex flex-col md:flex-row items-start gap-4" data-id="element-32">
            <div className="bg-orange-100 rounded-xl p-4 flex-shrink-0" data-id="element-33">
              <span className="text-4xl" data-id="element-34">🎁</span>
            </div>
            <div className="flex-1" data-id="element-35">
              <p className="text-sm font-bold text-orange-600 mb-1 font-heading" data-id="element-36">
                BONO 2
              </p>
              <h3 className="text-xl font-black font-heading text-gray-900 mb-2" data-id="element-37">
                Protocolos de Crisis
              </h3>
              <p className="text-gray-600 font-body mb-3" data-id="element-38">
                Qué hacer EXACTAMENTE en momentos de desborde
              </p>
              <div className="flex items-center gap-3" data-id="element-39">
                <span className="text-gray-400 line-through text-sm" data-id="element-40">
                  💰 Valor: USD 10
                </span>
                <span className="bg-green-100 text-green-700 font-bold text-sm px-3 py-1 rounded-full" data-id="element-41">
                  🎁 GRATIS
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Bonus 3 */}
        <div className="bg-white rounded-2xl p-6 mb-6 border-2 border-yellow-300 shadow-md relative overflow-hidden" data-id="element-42">
          <div className="absolute top-0 right-0 bg-red-600 text-white text-xs font-bold px-4 py-1 rounded-bl-xl" data-id="element-43">
            🎁 GRATIS HOY
          </div>
          <div className="flex flex-col md:flex-row items-start gap-4" data-id="element-44">
            <div className="bg-red-100 rounded-xl p-4 flex-shrink-0" data-id="element-45">
              <span className="text-4xl" data-id="element-46">🎁</span>
            </div>
            <div className="flex-1" data-id="element-47">
              <p className="text-sm font-bold text-red-600 mb-1 font-heading" data-id="element-48">
                BONO 3
              </p>
              <h3 className="text-xl font-black font-heading text-gray-900 mb-2" data-id="element-49">
                Plan 7 Días "Modo Calma"
              </h3>
              <p className="text-gray-600 font-body mb-3" data-id="element-50">
                Un sistema paso a paso para ver cambios reales en una semana
              </p>
              <div className="flex items-center gap-3" data-id="element-51">
                <span className="text-gray-400 line-through text-sm" data-id="element-52">
                  💰 Valor: USD 12
                </span>
                <span className="bg-green-100 text-green-700 font-bold text-sm px-3 py-1 rounded-full" data-id="element-53">
                  🎁 GRATIS
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Total bonus value */}
        <div className="bg-yellow-400 rounded-2xl p-5 text-center mt-8 cursor-pointer" onClick={scrollToPricing} data-id="element-54">
          <p className="text-lg md:text-xl font-black font-heading text-gray-900" data-id="element-55">
            🎁 Valor total de bonos:{' '}
            <span className="line-through" data-id="element-56">USD 31</span> →{' '}
            <span className="text-red-700 text-2xl" data-id="element-57">GRATIS</span> en esta oferta
          </p>
          <p className="text-sm text-gray-800 mt-1 font-bold" data-id="element-58">
            🎁 GRATIS POR EL DÍA DE HOY
          </p>
        </div>
      </div>
    </section>;
}